import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isGameCatalogApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getGameCatalogPayload = (res) => res?.data ?? null;

/** GET /admin/arcade/game-catalog */
export const listGameCatalog = () =>
  authFetch('/admin/arcade/game-catalog', { method: 'GET' });

/** GET /admin/arcade/game-catalog/:gameKey */
export const getGameCatalogItem = (gameKey) =>
  authFetch(`/admin/arcade/game-catalog/${encodeURIComponent(gameKey)}`, { method: 'GET' });

/** POST /admin/arcade/game-catalog */
export const createGameCatalogItem = (body) =>
  authFetch('/admin/arcade/game-catalog', {
    method: 'POST',
    body: JSON.stringify(body),
  });

/** PATCH /admin/arcade/game-catalog/:gameKey */
export const patchGameCatalogItem = (gameKey, body) =>
  authFetch(`/admin/arcade/game-catalog/${encodeURIComponent(gameKey)}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

/** DELETE /admin/arcade/game-catalog/:gameKey */
export const deleteGameCatalogItem = (gameKey) =>
  authFetch(`/admin/arcade/game-catalog/${encodeURIComponent(gameKey)}`, { method: 'DELETE' });
